module.exports = __webpack_public_path__ + "static/img/product1-3.91f8ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product1-3.jpg
// module id = t/i1
// module chunks = 0